import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App";

import "./index.scss";

function MSGameEngine() {
    return (
        <App />
    )
}

export default MSGameEngine;
